import * as React from 'react';
import type { ErrorInfo } from 'react';

import * as Sentry from '@sentry/react';

type ToolbarErrorBoundaryProps = {
  children: React.ReactNode;
};

type ToolbarErrorBoundaryState = {
  hasError?: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
};

/**
 * Simple error boundary component that catches uncaught errors within the tools or CourseToolBar
 */
class ToolbarErrorBoundary extends React.Component<ToolbarErrorBoundaryProps, ToolbarErrorBoundaryState> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    try {
      Sentry.captureMessage(`[ToolbarErrorBoundary]: error captured in CourseToolBar`, {
        extra: {
          error,
          errorInfo,
        },
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[ToolbarErrorBoundary]: Unable to capture this exception in Sentry', { error });
    }

    this.setState({ hasError: true });
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      // temporarily silently hide the toolbar
      // TODO: need design input if we need to show some meaningful error view instead
      return null;
    }

    return children;
  }
}

export default ToolbarErrorBoundary;
